"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../composite/evidence/dictionary-evidence/dictionary-evidence");
const table_cells_1 = require("../../composite/table/table-cells");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const dictionaryColumns = (0, dictionary_evidence_1.useDictionaryColumns)();
    return [
        dictionaryColumns.columnName,
        {
            datakey: 'counter',
            name: intl.formatMessage({
                id: 'EAS_SEQUENCES_COLUMN_COUNTER',
                defaultMessage: 'Počítadlo',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.NumberCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'format',
            name: intl.formatMessage({
                id: 'EAS_SEQUENCES_COLUMN_FORMAT',
                defaultMessage: 'Formát',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        dictionaryColumns.columnActive,
        dictionaryColumns.columnValidFrom,
        dictionaryColumns.columnValidTo,
        dictionaryColumns.columnCode,
        {
            datakey: 'description',
            name: intl.formatMessage({
                id: 'EAS_SEQUENCES_COLUMN_DESCRIPTION',
                defaultMessage: 'Popis',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'local',
            name: intl.formatMessage({
                id: 'EAS_SEQUENCES_COLUMN_LOCAL',
                defaultMessage: 'Lokální',
            }),
            width: 100,
            CellComponent: table_cells_1.TableCells.BooleanCell,
            sortable: true,
            filterable: true,
        },
        dictionaryColumns.columnOrder,
        dictionaryColumns.columnCreated,
        dictionaryColumns.columnCreatedBy,
        dictionaryColumns.columnUpdated,
        dictionaryColumns.columnUpdatedBy,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=sequences-columns.js.map